import type { PropsWithChildren } from 'react'
import { createContext } from 'react'

import { BrandCodeProvider } from '@jotta/grpc-connect-client/config/BrandCodeProvider'

import type { BrandTheme } from '../../types/BrandTheme'

export interface BrandContextValue {
  theme: BrandTheme
}
export const BrandContext = createContext<BrandContextValue | undefined>(
  undefined,
)
export function BrandContextProvider({
  theme,
  children,
}: PropsWithChildren<{ theme: BrandTheme }>) {
  return (
    <BrandContext.Provider
      value={{
        theme,
      }}
    >
      <BrandCodeProvider brandCode={theme.branding.brand}>
        {children}
      </BrandCodeProvider>
    </BrandContext.Provider>
  )
}
